import React, { PureComponent } from 'react';
import Grid from 'material-ui/Grid';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actions } from 'modules/admin';


export class Search extends PureComponent {

  nextPage = () => {
    const { currentPage, totalPages } = this.props;
    let nextPage;
    if (currentPage + 1 < totalPages) {
      nextPage = currentPage + 1;
      this.props.search(nextPage);
    }
  }

  previousPage = () => {
    const { currentPage } = this.props;
    let previousPage;
    if (currentPage > 0) {
      previousPage = currentPage - 1;
      this.props.search(previousPage);
    }
  }

  render() {
    const { currentPage, results, totalPages } = this.props;

    if (totalPages <= 1) {
      return null;
    }

    return (
      <Grid item xs={12} >
        <Grid container spacing={0} style={{ padding: '16px' }}>
          <Grid item xs={4}>
            <Typography variant="headline">Page { currentPage + 1 } of { totalPages } </Typography>
          </Grid>
          <Grid item xs={8}>
            <Grid container spacing={0} justify="flex-end">
              <Button
                onClick={this.previousPage}
                disabled={currentPage === 0}
              >Previous Page</Button>
              <Button
                onClick={this.nextPage}
                disabled={currentPage + 1 >= totalPages}
              >Next Page</Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

Search.propTypes = {
  currentPage: PropTypes.number.isRequired,
  results: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  search: PropTypes.func.isRequired,
  totalPages: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
  currentPage: state.admin.currentPage,
  results: state.admin.results,
  totalPages: state.admin.totalPages
});

const mapDispatchToProps = dispatch => ({
  search: (pageNumber) => {
    dispatch(actions.search(pageNumber));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Search);



// WEBPACK FOOTER //
// ./routes/Orders/containers/Refunds/containers/Results/components/PageNumbers/index.jsx